export const supportedRunStates = [
  'READY',
  'WAITING',
  'RUNNING',
  'FAILED',
  'COMPLETED',
  'RESERVED',
  'ARCHIVED',
  'CANCELLED',
  'PAUSED',
];

type RunState = (typeof supportedRunStates)[number];

export default RunState;
